"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _ramda = require("ramda");

var _reactI18next = require("react-i18next");

var _moment = _interopRequireDefault(require("moment"));

var _rcSelect = _interopRequireDefault(require("rc-select"));

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

var _masks = require("../../constants/masks");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};

var DateSelect = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DateSelect, _Component);

  var _super = _createSuper(DateSelect);

  function DateSelect(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, DateSelect);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (day, month, year) {
      var format = (0, _ramda.path)(['settings', 'format'], _this.props);

      if (format) {
        if (format === 'dd.MM.y') {
          _this.props.onChange(day && !(0, _ramda.isNil)(month) && year ? (0, _moment["default"])().year(year).month(month - 1).date(day).format('DD.MM.YYYY') : day || !(0, _ramda.isNil)(month) || year ? 'incomplete' : undefined);
        } else if (format === 'MM.y') {
          _this.props.onChange(year && !(0, _ramda.isNil)(month) ? (0, _moment["default"])().year(year).month(month - 1).format('MM.YYYY') : year || !(0, _ramda.isNil)(month) ? 'incomplete' : undefined);
        } else if (format === 'y') {
          _this.props.onChange(year ? (0, _moment["default"])().year(year).format('YYYY') : undefined);
        }
      } else {
        _this.props.onChange(day && !(0, _ramda.isNil)(month) && year ? (0, _moment["default"])().year(year).month(month - 1).date(day).format('YYYYMMDD') : day || !(0, _ramda.isNil)(month) || year ? 'incomplete' : undefined);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeDay", function (e) {
      var _this$state = _this.state,
          month = _this$state.month,
          year = _this$state.year;
      var day = e.target.value;

      _this.setState({
        day: day
      });

      _this.onChange(day, month, year);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeMonth", function (month) {
      var _this$state2 = _this.state,
          current = _this$state2.day,
          year = _this$state2.year;
      var day = month && !year && (0, _moment["default"])().month(month - 1).daysInMonth() < current ? (0, _moment["default"])().month(month - 1).daysInMonth() : month && year && (0, _moment["default"])().month(month - 1).year(year).daysInMonth() < current ? (0, _moment["default"])().month(month - 1).year(year).daysInMonth() : current;

      _this.setState({
        month: month,
        day: day
      });

      _this.onChange(day, month, year);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeYear", function (e) {
      var _this$state3 = _this.state,
          day = _this$state3.day,
          month = _this$state3.month;
      var year = e.target.value;

      _this.setState({
        year: year
      });

      _this.onChange(day, month, year);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlurDay", function () {
      var _this$state4 = _this.state,
          current = _this$state4.day,
          month = _this$state4.month,
          year = _this$state4.year;
      var day = !month && current > 31 ? 31 : month && !year && (0, _moment["default"])().month(month - 1).daysInMonth() < current ? (0, _moment["default"])().month(month - 1).daysInMonth() : month && year && (0, _moment["default"])().month(month - 1).year(year).daysInMonth() < current ? (0, _moment["default"])().month(month - 1).year(year).daysInMonth() : current;

      _this.setState({
        day: day
      });

      _this.onChange(day, month, year);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlurYear", function () {
      var _this$state5 = _this.state,
          current = _this$state5.day,
          month = _this$state5.month,
          year = _this$state5.year;

      if (month && year) {
        var daysInMonth = (0, _moment["default"])().month(month).year(year).daysInMonth();

        if (daysInMonth < current) {
          _this.setState({
            day: daysInMonth
          });

          _this.onChange(daysInMonth, month, year);
        }
      }
    });
    var _day = undefined;
    var _month = undefined;
    var _year = undefined;
    var _format = props.settings.format,
        value = props.input.value;

    if (value) {
      if (_format === 'dd.MM.y') {
        var date = (0, _moment["default"])(value, 'DD.MM.YYYY');
        _day = date.date();
        _month = date.month() + 1;
        _year = date.year();
      } else if (_format === 'MM.y') {
        var _date = (0, _moment["default"])(value, 'MM.YYYY');

        _month = _date.month() + 1;
        _year = _date.year();
      } else if (_format === 'y') {
        var _date2 = (0, _moment["default"])(value, 'YYYY');

        _year = _date2.year();
      }
    }

    _this.state = {
      day: _day,
      month: _month,
      year: _year
    };
    _this.selectContainer = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(DateSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prev) {
      if (!this.props.input.value && prev.input.value) {
        this.setState({
          day: '',
          month: null,
          year: ''
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          settings = _this$props.settings,
          t = _this$props.t,
          disabled = _this$props.disabled,
          _this$props$input = _this$props.input,
          name = _this$props$input.name,
          value = _this$props$input.value;
      var format = (0, _ramda.path)(['format'], settings);
      var showDay = format ? (0, _ramda.contains)('dd', format) : true;
      var showMonth = format ? (0, _ramda.contains)('MM', format) : true;
      var showYear = format ? (0, _ramda.contains)('y', format) : true;
      var _this$state6 = this.state,
          day = _this$state6.day,
          month = _this$state6.month,
          year = _this$state6.year;
      var options = t('MONTHS', {
        returnObjects: true
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.selectContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: name,
        className: "jobot-forms__formDateSelect ".concat(styles.formDateSelect)
      }, showDay && /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], {
        id: "".concat(name, "-day"),
        className: styles.formInput,
        value: day || '',
        onChange: this.onChangeDay,
        onBlur: this.onBlurDay,
        mask: _masks.DAY_MASK,
        placeholderChar: "\u2000",
        placeholder: t('placeholders.datePicker.day'),
        keepCharPositions: false,
        disabled: disabled,
        guide: true
      }), showMonth && /*#__PURE__*/_react["default"].createElement(_rcSelect["default"], {
        id: "".concat(name, "-month"),
        disabled: disabled,
        value: month || undefined,
        onChange: this.onChangeMonth,
        options: options,
        placeholder: t('placeholders.datePicker.month'),
        prefixCls: "jobot-forms-rc-select",
        className: "jobot-forms-month-select",
        getPopupContainer: function getPopupContainer() {
          return _this2.selectContainer.current;
        }
      }), showYear && /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], {
        id: "".concat(name, "-year"),
        disabled: disabled,
        className: styles.formInput,
        value: year || '',
        onChange: this.onChangeYear,
        onBlur: this.onBlurYear,
        mask: _masks.YEAR_MASK,
        placeholderChar: "\u2000",
        placeholder: t('placeholders.datePicker.year'),
        keepCharPositions: false,
        guide: true
      })));
    }
  }]);
  return DateSelect;
}(_react.Component);

var _default = (0, _withFieldWrapper["default"])((0, _reactI18next.withTranslation)()(DateSelect));

exports["default"] = _default;